import React from 'react';
import PropTypes from 'prop-types';

import RacingThemeSearchFilterChip from './RacingThemeSearchFilterChip';
import { SEARCH_ACTIVE_FILTERS } from '../RacingThemeSearch/searchResultsContent';
import styles from './RacingThemeSearchActiveFilters.module.css';

const DEPARTMENT_ORDER = ['shop', 'book', 'partner'];

/**
 * Group filter chips by main department, keeping non-category chips last.
 *
 * @param {Array} filters
 * @returns {Array<{ department: string|null, filters: Array }>}
 */
const groupFiltersByDepartment = (filters = []) => {
  const buckets = {
    shop: [],
    book: [],
    partner: [],
    other: [],
  };

  filters.forEach(filter => {
    const department = typeof filter === 'object' ? filter.department : null;
    if (DEPARTMENT_ORDER.includes(department)) {
      buckets[department].push(filter);
    } else {
      buckets.other.push(filter);
    }
  });

  return [...DEPARTMENT_ORDER, 'other']
    .filter(key => buckets[key].length > 0)
    .map(key => ({
      department: key === 'other' ? null : key,
      filters: buckets[key],
    }));
};

/**
 * Active search filter chips row.
 */
const RacingThemeSearchActiveFilters = props => {
  const { filters = SEARCH_ACTIVE_FILTERS, onRemove } = props;

  if (!filters || filters.length === 0) {
    return null;
  }

  const groups = groupFiltersByDepartment(filters);

  return (
    <div className={styles.activeFilters}>
      {groups.map(group => (
        <div
          key={group.department || 'other'}
          className={styles.filterChipGroup}
          data-department={group.department || undefined}
          role="group"
          aria-label={group.department ? `${group.department} filters` : 'Other filters'}
        >
          {group.filters.map(filter => {
            const label = typeof filter === 'string' ? filter : filter.label;
            const key = typeof filter === 'string' ? filter : filter.id;
            return (
              <RacingThemeSearchFilterChip
                key={key}
                label={label}
                department={typeof filter === 'object' ? filter.department : null}
                onRemove={() => {
                  if (typeof onRemove === 'function') {
                    onRemove(filter);
                  }
                }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

RacingThemeSearchActiveFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        department: PropTypes.oneOf(['shop', 'book', 'partner']),
      }),
    ])
  ),
  onRemove: PropTypes.func,
};

export default RacingThemeSearchActiveFilters;
